module.exports = function (options)
{

    return {
        ...options,

        // Overwrite options
        // language: 'en',

        // Add styles
        stylesSet: [
            { name: 'Normal', element: 'span', attributes: {'class': ''} },

            { name: 'Witte knop', element: 'a', attributes: { 'class': 'btn-white' } },
            { name: 'Grijze knop', element: 'a', attributes: { 'class': 'btn-gray' } },
            { name: 'Wit vierkant met pijl knop', element: 'a', attributes: { 'class': 'btn-transsquare' } },
            { name: 'Groene knop', element: 'a', attributes: { 'class': 'btn-green' } },

            { name: 'Groot, dik', element: 'span', attributes: { 'class': 'bigbold' } },
            { name: 'Groot, dun', element: 'span', attributes: { 'class': 'smallthin' } },
            { name: 'Middel, dun', element: 'span', attributes: { 'class': 'middle' } },
            { name: 'Heading 1', element: 'span', attributes: { 'class': 'h1' } },
            { name: 'Heading 2', element: 'span', attributes: { 'class': 'h2' } },
            { name: 'Heading 3', element: 'span', attributes: { 'class': 'h3' } },
            { name: 'Heading 4', element: 'span', attributes: { 'class': 'h4' } },
        ],

        // Allow tags.
        format_tags: 'p;h1;h2;h3;h4;h5',

    };

};
